module.exports = __webpack_public_path__ + "static/media/YAM.22df3cbf.svg";